import { ICreateUsuarioUseCase } from "../../../presentation/useCases/create/create_usuario_use_case";
import { IAdministracaoRepository } from "../../repositories/administracao_repository";

/**
 * CreateUsuarioUseCase
 */

export class CreateUsuarioUseCase implements ICreateUsuarioUseCase {
  constructor(private readonly repository: IAdministracaoRepository) { }
  async execute(
    nome: string,
    login: string,
    senha: string,
    email: string,
    centroCustoRestrito: boolean,
    bloqueado: boolean,
    idFuncionario?: number,
    isConfigured?: boolean,

    gruposUsuario?: number[],
    restricoesCentroCusto?: number[],
  ): Promise<number> {
    const idUsuario = await this.repository.createUsuario(
      nome,
      login,
      senha,
      email,
      centroCustoRestrito,
      bloqueado,
      idFuncionario,
      isConfigured,

      gruposUsuario,
      restricoesCentroCusto,
    );
    return idUsuario;
  }
}
